// src/pages/Blog.jsx
import React from 'react';
import '../CSS/Blog.css';
import { Link } from 'react-router-dom';
import blogPosts from '../data/BlogPost';
import '../CSS/Projects.css';

const Blog = () => {
    return (
        <div className="projects-container">
      <h1>My Blog</h1>
      <div className="projects-grid">
        {blogPosts.map((post) => (
          <div key={post.id} className="project-card">
            <img src={post.images[0]} alt={post.name} className="project-image" />
            <h2>{post.name}</h2>
            <p>{post.description}</p>
            <div className="project-links">
              <Link to={`/blog/rpx/${post.id}`} className="project-button">
                View
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
    );
};

export default Blog;